import {
	VERSION_RELATED_LINKS_PROVIDER_ID_PROD,
	VERSION_RELATED_LINKS_PROVIDER_ID_STG,
} from '../../model/constants.tsx';

export const isVersionRelatedLinksProvider = (id: string): boolean =>
	id === VERSION_RELATED_LINKS_PROVIDER_ID_PROD || id === VERSION_RELATED_LINKS_PROVIDER_ID_STG;
